export const SALTO_ACCESS_GROUPS = {
  resident: {
    autoAssign: 'shouldAutoAssignApartmentDoor',
    levels: 'residentAccessLevels',
    zones: 'residentZones',
  },
  visitor: {
    autoAssign: 'shouldAutoAssignUserAccessLevel',
    levels: 'visitorAccessLevels',
    zones: 'visitorZones',
  },
} as const

export type SaltoAccessGroupKey = keyof typeof SALTO_ACCESS_GROUPS
